import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const Field = ({ label, hint, children }) => (
  <label className="block space-y-1">
    <span className="text-sm font-semibold text-[#0D3B2B]">{label}</span>
    {children}
    {hint && <span className="block text-xs text-[#7B968B]">{hint}</span>}
  </label>
);

export const TextField = ({ label, hint, testid, ...p }) => (
  <Field label={label} hint={hint}><Input data-testid={testid} className="h-12 rounded-xl bg-white text-base" {...p} /></Field>
);

export const AreaField = ({ label, testid, ...p }) => (
  <Field label={label}><Textarea data-testid={testid} className="min-h-[84px] rounded-xl bg-white text-base" {...p} /></Field>
);

export const AddressFields = ({ form, set }) => {
  const { t } = useApp();
  return (
    <div className="space-y-3">
      <AreaField label={t("Pickup address")} testid="address-input" placeholder={t("House / shop no., street, area")}
        value={form.address} onChange={(e) => set({ address: e.target.value })} />
      <TextField label={t("Landmark (optional)")} testid="landmark-input" placeholder={t("e.g. Near Birla Mandir")}
        value={form.landmark} onChange={(e) => set({ landmark: e.target.value })} />
    </div>
  );
};

export const PrivacyNotice = () => {
  const { t } = useApp();
  return (
    <div className="rounded-2xl bg-[#EAEFEA] p-4 text-sm leading-relaxed text-[#4A6358]" data-testid="privacy-notice">
      <p className="mb-1 font-bold text-[#0D3B2B]">{t("Your privacy")}</p>
      <p>{t("We collect your name, phone numbers, email, address, map location and payment details only to arrange pickups, contact you and pay you for scrap.")}</p>
      <p className="mt-1">{t("Payment details are encrypted. We never sell your data. The leaderboard shows only a masked name, customer type and general area, and you can hide yourself any time in Settings.")}</p>
      <p className="mt-2 flex gap-4 font-semibold"><a href="/privacy.html" className="text-[#2E9E6B]" data-testid="privacy-policy-link">{t("Privacy Policy")}</a><a href="/terms.html" className="text-[#2E9E6B]" data-testid="terms-link">{t("Terms of Service")}</a></p>
    </div>
  );
};
